import type { useTranslation } from "react-i18next";

import { ApiError } from "../../api/apiError";

export type TFunction = ReturnType<typeof useTranslation>["t"];

// Текст ошибки запроса для человека (ADR-0091 § 5, § 7): `ApiError` — по
// статусу ответа, прочее — «нет связи». Технический `message` не выводится.
export function requestErrorText(error: unknown, t: TFunction): string {
  if (error instanceof ApiError) {
    return t("task.actionFailedHttp", { status: error.status });
  }
  return t("task.actionFailedNetwork");
}
